import { QueryClient } from '@tanstack/react-query';
import { ApiError, retryApiRead, apiReadRetryDelay } from './api-error';

// Create a custom fetch function that includes credentials
const customFetch = async (url: string, options: RequestInit = {}) => {
  const response = await fetch(url, {
    ...options,
    redirect: 'error', // Never forward mutation bodies or trust redirected API data.
    credentials: 'include', // Always include cookies
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

  if (!response.ok) {
    throw new ApiError(response.status, response.headers.get('Retry-After'));
  }

  return response.json();
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      queryFn: async ({ queryKey }) => {
        const [url] = queryKey as [string];
        return customFetch(url);
      },
      staleTime: 0, // AGENT B FIX: Force fresh data for multi-organization switching
      gcTime: 1000 * 60 * 10, // 10 minutes
      retry: retryApiRead,
      retryDelay: apiReadRetryDelay,
    },
    mutations: {
      retry: false,
      mutationFn: async ({ url, method, data }: any) => {
        return customFetch(url, {
          method,
          body: data ? JSON.stringify(data) : undefined,
        });
      },
    },
  },
});
